import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('clusters');
export const actions = helper.createActions('clusters', actionTypes);